import { render } from "./FadeIn.vue?vue&type=template&id=5538bdc2&scoped=true"
import script from "./FadeIn.vue?vue&type=script&lang=js"
export * from "./FadeIn.vue?vue&type=script&lang=js"

import "./FadeIn.vue?vue&type=style&index=0&id=5538bdc2&scoped=true&lang=css"

import exportComponent from "/Users/rs/Development/alisops/osod-form/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5538bdc2"]])

export default __exports__